"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStepper = void 0;
var react_1 = require("react");
var maxInputLength = 4;
var minMax = function (value, options) {
    return Math.min(Math.max(parseInt(value), options.min), options.max);
};
var useStepper = function (_a) {
    var max = _a.max, min = _a.min, handleChange = _a.handleChange, value = _a.value;
    var _b = (0, react_1.useState)(undefined), internalValue = _b[0], setInternalValue = _b[1];
    var handleInput = (0, react_1.useCallback)(function (event) {
        var newValue = event.target.value;
        if (newValue.length > maxInputLength) {
            return;
        }
        var numericValue = parseInt(newValue, 10);
        if (!Number.isNaN(numericValue) || newValue === '') {
            setInternalValue(newValue === '' ? '' : numericValue.toString());
        }
    }, [setInternalValue]);
    var handleIncrement = function () { return handleChange(Math.min(value + 1, max), 'plus'); };
    var handleDecrement = function () { return handleChange(Math.max(value - 1, min), 'minus'); };
    var handleInputBlur = function () {
        setInternalValue(undefined);
        if (Number(internalValue) !== value && internalValue !== '') {
            handleChange(minMax(internalValue, { min: min, max: max }), 'qty field');
        }
    };
    var handleInputFocus = function (event) {
        event.target.select();
        setInternalValue(value.toString());
    };
    return {
        handleInput: handleInput,
        handleInputFocus: handleInputFocus,
        handleInputBlur: handleInputBlur,
        handleIncrement: handleIncrement,
        handleDecrement: handleDecrement,
        displayValue: internalValue !== undefined ? internalValue : value,
    };
};
exports.useStepper = useStepper;
//# sourceMappingURL=useStepper.js.map